// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  name: 'dev',
  production: false,
  region: 'NA',
  appUrl: 'https://managed-event-registry.dev.zonarsystems.net/',

  apiBase: {
    url: 'https://zonar-nonprod-dev.apigee.net'
  },

  coreEntityApiBase: {
    url: 'https://api-dev.zonarsystems.net/core/v1'
  },

  userPreferencesApiBase: {
    url: 'https://api-dev.zonarsystems.net/alert/v1'
  },

  authEnv: 'development',

  auth: {
    clientID: 'tJb3cp5GdQCzHjQaLURUdplDHFSBPzp0',
    domain: 'zonar-dev.auth0.com',
    audience: 'http://apidev.zonarsystems.net/',
    // These come from the Core APIs as your application is built.
    applicationId: '07e013f6-3351-49f6-ac7d-b94d8ea7d1fd',
    defaultZonarRole: '27267eac-1422-46f9-9547-9c4d21a12130',
    useRefreshTokens: true
  },

  pendo: {
    url: 'https://cdn.pendo.io/agent/static/'
  },

  googleTagManager: {
    id: 'GTM-PM9R42P',
    auth: '',
    environment: ''
  },

  datadog: {
    applicationId: 'ae864ef9-6e2d-453b-b0ac-999c8219618a',
    clientToken: 'pub8b104aad726d6366de4823da4068593b',
    site: 'us5.datadoghq.com',
    tagEnvironment: 'dev'
  },

  i18n: {
    supportedLanguages: [
      'en',
      'en-US',
      'de-DE',
      'en-GB',
      'it',
      'fr-FR',
      'de',
      'es-ES'
    ],
    defaultLanguage: 'en-US'
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
